import * as React from "react";
import { UserFilterSettingsModel, UserGridModel, UserForGridModel, UserAdminModel } from "../../models/user/";
import UserService from '../../services/userService';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Spinner from '../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { UserFilter } from './userFilter';
import UserList from './userList';
import UserAddEditDialog from './userAddEditDialog';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./medicinesAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  isLoading: boolean;
  error: any;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  userGrid: UserGridModel,
  userSettings: UserFilterSettingsModel
  users: Array<UserForGridModel>;
  currentUser: UserAdminModel;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
}

const initFrom = 0;
const numberOfRows = 10;

class UserContainer extends React.Component<IProps, IState> {

  userService = new UserService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      validationMessage: '',
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      users: new Array<UserForGridModel>(0),
      currentUser: new UserAdminModel(),
      userGrid: new UserGridModel(),
      userSettings: new UserFilterSettingsModel(),
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
    };
  }

  // events
  componentDidMount() {
    this.getAllUsers(this.state.from, this.state.numberOfRows);
  }


  getAllUsers(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.userService.getAllUsers(from, numberOfRows, this.state.userSettings).then(
      (data: UserGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          users: data.users,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }


  // handles
  handleAddAndEditClick = id => {
    if (!id) { // Add			
      this.setCurrentUser(new UserAdminModel());
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.userService.getUser(id)
        .then(
          (data: UserAdminModel) => {
            this.setCurrentUser(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error,
              isLoading: false
            });
          }
        );
    }
  };

  getUser = (id) => {
    this.userService.getUser(id)
      .then(
        (data: UserAdminModel) => {
          this.setCurrentUser(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleDeleteClick = (id) => {
    this.getUser(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteUser(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.userService.deleteUser(id)
      .then(
        data => {
          this.getAllUsers(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSaveButton = (currentUser: UserAdminModel, close: boolean) => {
    this.setState({
      isLoading: true
    });

    if (!currentUser.userId) { // Add
      this.userService.addUser(currentUser)
        .then(
          (data) => {
            if (close) {
              this.showEditDialog(false);

            }
            this.setCurrentUser(new UserAdminModel());
            this.getAllUsers(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setCurrentUser(new UserAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.userService.editUser(currentUser.userId, currentUser)
        .then(
          (data) => {
            if (close) {
              this.showEditDialog(false);
            }
            this.setCurrentUser(new UserAdminModel());
            this.getAllUsers(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setCurrentUser(new UserAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  setCurrentUser(user: UserAdminModel) {
    this.setState({ currentUser: { ...user } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllUsers(startIndex, this.state.numberOfRows);
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.userService.getAllUsers(initFrom, numberOfRows, settings).then(
      (data: UserGridModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          users: data.users,
          userSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  // render
  public render() {

    const { users, isLoading, error } = this.state;

    return (
      <div>

        <h3>Users</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        {this.state.isVisibleDialogWrap ? (
          <UserAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentUser={this.state.currentUser}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <button
            onClick={() => this.handleAddAndEditClick(null)}
            className="btn btn-success"
            style={{ marginRight: "5px" }}>
            Add New
         			 </button>
        </div>

        <UserFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
        />

        <UserList
          users={users}
          rows={numberOfRows}
          totalRecords={this.state.totalRecordsCount}
          onPageClick={this.handleOnPageClick}
          first={this.state.from}
          loading={Spinner}
          editClick={this.handleAddAndEditClick}
          deleteClick={this.handleDeleteClick}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteUser(this.state.currentUser.userId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentUser.name}"?
        </ConfirmDialog>
      </div>
    );
  }
}

export default UserContainer;
